{
  "id": "njord",
  "pantheon": "norse",
  "name": {
    "pt-BR": "Njord",
    "en": "Njord"
  },
  "icon": "gods/njord",
  "portrait": "gods/njord-portrait",
  "age": "heroic",
  "freeUnitsOnAgeUp": {
    "mountain-giant": 1
  },
  "unlocks": ["mountain-giant", "wrath-of-the-deep", "ring-giver", "vikings", "jotuns"],
  "powers": ["walking-woods"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Odin, Loki. Focus: cavalry. Age tech HeroicAgeNjord."
  },
  "fieldMeta": {
    "freeUnitsOnAgeUp": {
      "source": "Game files 19.17020 (techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "HeroicAgeNjord: CreateUnit mountain-giant quantity 1, generator AbstractTemple (spawns at a Temple)."
    }
  }
}
